import { Component, ViewContainerRef } from '@angular/core';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { RolePermissionsModel } from '../../models/role/role-permissions-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-role-permissions',
  templateUrl: './role-permissions.component.html',
  //styleUrls: ['./role-permissions.component.css']
})
/** role-permissions component*/
export class RolePermissionsComponent {
  /** role-permissions ctor */

  permissions: RolePermissionsModel[];
  roleID: string = "";

  constructor(private readonly rolePermissionService: RolePermissionService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastsManager,
    private readonly router: Router,
    vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.roleID = this.activatedRoute.snapshot.paramMap.get('id');
    this.GetModulesWithRoleAccess();
  }

  GetModulesWithRoleAccess() {
    this.rolePermissionService.GetModulesWithRoleAccess(this.roleID).subscribe(
      data => {
        if (data != null) {
          this.permissions = data;
        }
      });
  }

  UpdatePermissionStatus(permission) {

    if (permission.parentID == 0) {
      this.permissions.forEach(x => {
        if (x.parentID == permission.moduleID) {
          x.isRoleAllowed = !permission.isRoleAllowed;
        }
      });
    }

    else {
      this.permissions.forEach(x => {
        if (x.moduleID == permission.parentID && !permission.isRoleAllowed) {
          x.isRoleAllowed = true;
        }
      });
    }

    permission.isRoleAllowed = !permission.isRoleAllowed;
  }

  UpdateRoleModules() {

    let moduleIds: number[] = [];
    this.permissions.forEach(x => {
      if (x.isRoleAllowed) {
        moduleIds.push(x.moduleID);
      }
    });
    
    this.rolePermissionService.UpdateRoleModules(this.roleID, moduleIds).subscribe(
      data => {
        if (data.status == 200) {
          this.toastr.success('Permissions have been upadated', 'Success');
          setTimeout(() => {
            this.router.navigate(["/role-list"]);
          }, 2000);
        }
        else {
          this.toastr.error(data.message, 'Error');
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/role-components/role-permissions/role-permissions.component.ts